import React from "react";
import "./modal.css";
import FormButton from "../../ui/FormButton";

const CombinedModal = ({ showModal, closeModal }) =>
{
    const modalClassName = showModal
        ? "modalContainer active"
        : "modalContainer";

    return (
        <>
            {showModal && (
                <div className="modalBackground" onClick={() => closeModal(false)}>
                    <div className={modalClassName} onClick={(e) => e.stopPropagation()}>
                        <div className="closeBtn">
                            <button onClick={() => closeModal(false)}>X</button>
                        </div>

                        <div className="modalContent center">
                            {/* BIPOC Section */}
                            <div className="modal-section">
                                <div className="header">
                                    <h1 style={{ textTransform: "capitalize" }}>
                                        Join our database!
                                    </h1>
                                </div>
                                <br />
                                <div className="content-wrapper">
                                    <p style={{ textAlign: "center" }}>
                                        Mesh of Mothers Foundation Inc. is searching for <br />
                                        <b style={{ color: "#0b5c77" }}>BIPOC Professionals</b> in the{" "}
                                        <b style={{ color: "#0b5c77" }}>
                                            {" "}
                                            maternal health, family health, allied health and birthing
                                            areas{" "}
                                        </b>{" "}
                                        to expand our database of resources!
                                    </p>
                                    <br />
                                    <FormButton
                                        text="BIPOC Professional Form"
                                        link="https://form.jotform.com/232890162361050"
                                    />
                                </div>
                            </div>

                            {/* Divider */}
                            <div style={{
                                width: "100%",
                                height: "1px",
                                backgroundColor: "#e0e0e0",
                                margin: "30px 0"
                            }} />

                            {/* Hamper Section */}
                            <div className="modal-section">
                                <div className="header">
                                    <h1 style={{ textTransform: "capitalize" }}>
                                        Black, African and Caribbean New Mom Hamper Program
                                    </h1>
                                </div>
                                <br />
                                <div className="content-wrapper">
                                    <article className="left-align">
                                        Eligibility Service targeted to:
                                        <ul>
                                            <li>
                                                • Black moms who are residents of Edmonton and surrounding
                                                area
                                            </li>
                                            <li>• Black moms in need of baby/ mom supplies</li>
                                            <li>• Babies must be 12months and under </li>
                                        </ul>
                                        <p>
                                            Please note that the hamper program is not targeted at
                                            expectant mothers.
                                        </p>
                                    </article>
                                    <br />
                                    <FormButton text="Register" link="/register" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CombinedModal;